import { useEffect } from "react";
import { trackPhoneClick, trackEmailClick } from "@/lib/analytics";

/**
 * Delegated document-level click listener that fires GTM events for every
 * tel: and mailto: link click site-wide — no changes required to individual
 * components. Attach once at the layout level.
 */
export default function useClickTracking() {
  useEffect(() => {
    const onClick = (e) => {
      const a = e.target && e.target.closest ? e.target.closest("a[href]") : null;
      if (!a) return;
      const href = a.getAttribute("href") || "";
      if (href.startsWith("tel:")) {
        trackPhoneClick(href.slice(4), a.dataset.trackSource || location.pathname);
      } else if (href.startsWith("mailto:")) {
        const email = href.slice(7).split("?")[0];
        trackEmailClick(email, a.dataset.trackSource || location.pathname);
      }
    };
    document.addEventListener("click", onClick, { capture: true });
    return () => document.removeEventListener("click", onClick, { capture: true });
  }, []);
}
